import { DatePipe, AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
  input,
  inject,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { MessageModule } from 'primeng/message';
import { PopoverModule } from 'primeng/popover';
import { PaginatorModule } from 'primeng/paginator';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import {
  AuthSevices,
  CommentsService,
  CommonService,
  OpportunityService,
  TaskService,
  TimeconversionService,
} from '@fitness-force/api';
import { Store } from '@ngrx/store';
import {
  BehaviorSubject,
  Observable,
  map,
  forkJoin,
  of,
  catchError,
} from 'rxjs';
import type {
  ClientTasks,
  Comments,
  Country,
  CreateComments,
  LatestTask,
  OpportunityStageMasterResponse,
  STAGE_MASTER_MODEL,
  TASK_TYPE,
  TENANTSINTERFACE,
  Task,
  TaskOutcomeDetails,
  UpdateOpportunityRequest,
  UpdateTask,
} from '@fitness-force/models';
import {
  COUNTRY_MASTER_STATE,
  SERVICETYPE_LIST_STATE,
  STAGE_MASTER_STATE,
  TENANTS_INFO,
} from '@fitness-force/state';
import { TaskAssignToType, TaskStatus, TaskType } from '@fitness-force/enum';
import { CONSTANTS_CRM } from '@fitness-force/constants';
import { EditorModule } from 'primeng/editor';
import { ChipModule } from 'primeng/chip';
import { AssignedToComponent } from '@fitness-force/common/assigned-to';
import { InputNumberModule } from 'primeng/inputnumber';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TourOutcomeComponent } from '../../out-come/tour-outcome/tour-outcome.component';
import { CallOutcomeComponent } from '../../out-come/call-outcome/call-outcome.component';
import { StaffInfoComponent } from '../../staff/staff-info/staff-info.component';
import { TaskCreateComponent } from '../../task/task-create/task-create.component';
import { InputNumberComponent } from '../../input-number/input-number.component';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';

@Component({
  selector: 'client-task-tab',
  templateUrl: './client-task-tab.component.html',
  styleUrls: ['./client-task-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DividerModule,
    ToastModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    DialogModule,
    AvatarModule,
    CheckboxModule,
    TagModule,
    DatePickerModule,
    TableModule,
    TabsModule,
    SkeletonModule,
    PopoverModule,
    PaginatorModule,
    StyleClassModule,
    MessageModule,
    EditorModule,
    ChipModule,
    AssignedToComponent,
    InputNumberModule,
    CurrencyformatPipe,
    AutoCompleteModule,
    StaffInfoComponent,
    TourOutcomeComponent,
    CallOutcomeComponent,
    TaskCreateComponent,
    InputNumberComponent,
    TranslateModule,
    DateTimeFormatPipe,
    AsyncPipe,
    NgClass,
  ],
})
export class ClientTaskTabComponent implements OnInit {
  private store = inject(Store);
  private translate = inject(TranslateService);
  private messageService = inject(MessageService);
  private timeService = inject(TimeconversionService);
  private fb = inject(UntypedFormBuilder);
  datepipe = inject(DatePipe);
  private taskService = inject(TaskService);
  private authService = inject(AuthSevices);
  private commonService = inject(CommonService);
  private opportunityService = inject(OpportunityService);
  private commentsService = inject(CommentsService);
  private sanitizer = inject(DomSanitizer);
  changeDetectorRef = inject(ChangeDetectorRef);

  readonly clientId = input<number>(0);

  getAccessTenantList$: Observable<any>;
  tags: string[] | undefined;
  tenantId = 0;
  loading = new BehaviorSubject<boolean>(true);
  clientTasks$ = new BehaviorSubject<Task[]>([]);
  complitedTasks$ = new BehaviorSubject<Task[]>([]);
  plannedTasks$ = new BehaviorSubject<Task[]>([]);
  convertibility: any = CONSTANTS_CRM.OPPORTUNITY_CONVERTITBILITY;
  selectedConvertibility!: any;
  clientTasks: Task[] = [];
  TaskApportunityInfoForm: UntypedFormGroup;
  formGroup: UntypedFormGroup;
  country: Country;
  opportunityStageCollection!: Option[];
  serviceTypeCollection!: any;
  currentUserDetails: any;
  filtertedServiceType!: Option[];
  showClientSidebar: boolean = true;
  dynamicArray: ShowHideControl[] = [];
  outcomeDetail = <TaskOutcomeDetails>{};
  showMeetingOutcomePopup: boolean = false;
  showCallOutcomePopup: boolean = false;
  activeClientId: any;

  showTaskCreate: boolean = false;
  selectedClientIds: never[];
  showTaskMultiple: boolean = false;

  showStaticRow: boolean = true;

  tableData: any[] = [{ field1: '', field2: '' }];

  showSkeleton: boolean = true;
  clientIds: any = [];
  btnLoading = false;
  minimumDate = new Date();

  // Pagination for scheduled tasks - server-side
  scheduledPage: number = 1;
  scheduledPageSize: number = 10;
  scheduledTotalItems: number = 0;
  scheduledTotalPages: number = 0;
  scheduledLoading: boolean = false;

  // Pagination for completed tasks - server-side
  completedPage: number = 1;
  completedPageSize: number = 10;
  completedTotalItems: number = 0;
  completedTotalPages: number = 0;
  completedLoading: boolean = false;

  // Tab management
  activeTabIndex: number = 0;

  ngOnInit(): void {
    this.componentInit();
  }

  /**
   * Handle tab change event
   */
  onTabChange(event: any): void {
    this.activeTabIndex = parseInt(event, 10);
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
    this.store.select(COUNTRY_MASTER_STATE).subscribe((country: Country) => {
      this.country = country;
    });
    this.currentUserDetails = this.authService.currentUserDetails();
    this.formGroup = this.fb.group({});
    this.BindOpportunityStageMaster();
    this.BindServiceType();

    // Only fetch tasks if clientId is valid
    const clientId = this.clientId();
    if (clientId && clientId > 0) {
      this.loadAllTasks();
    } else {
      this.loading.next(false);
      this.showSkeleton = false;
    }
  }

  loadAllTasks() {
    this.showSkeleton = true;
    this.loading.next(true);

    const scheduledParams: TASK_TYPE[] = [
      { paramName: 'PageSize', paramValue: this.scheduledPageSize.toString() },
      { paramName: 'PageNumber', paramValue: this.scheduledPage.toString() },
      { paramName: 'Status', paramValue: TaskStatus.Scheduled.toString() },
    ];

    const completedParams: TASK_TYPE[] = [
      { paramName: 'PageSize', paramValue: this.completedPageSize.toString() },
      { paramName: 'PageNumber', paramValue: this.completedPage.toString() },
      { paramName: 'Status', paramValue: TaskStatus.Completed.toString() },
    ];

    forkJoin({
      scheduled: this.taskService
        .GetAllTaskByClientId(this.clientId(), scheduledParams)
        .pipe(
          catchError((error) => {
            console.error('Error fetching scheduled tasks:', error);
            return of({
              items: [],
              total_items: 0,
              total_pages: 0,
              current_page: 1,
            } as ClientTasks);
          }),
        ),
      completed: this.taskService
        .GetAllTaskByClientId(this.clientId(), completedParams)
        .pipe(
          catchError((error) => {
            console.error('Error fetching completed tasks:', error);
            return of({
              items: [],
              total_items: 0,
              total_pages: 0,
              current_page: 1,
            } as ClientTasks);
          }),
        ),
    }).subscribe({
      next: (results) => {
        // Process scheduled tasks
        if (results.scheduled && results.scheduled.items.length > 0) {
          const scheduledData = results.scheduled.items.sort(
            (a, b) =>
              new Date(b.scheduled_date).getTime() -
              new Date(a.scheduled_date).getTime(),
          );
          this.plannedTasks$.next(scheduledData);
          this.scheduledTotalItems = results.scheduled.total_items;
          this.scheduledTotalPages = results.scheduled.total_pages;
          this.scheduledPage = results.scheduled.current_page;
        } else {
          this.plannedTasks$.next([]);
          this.scheduledTotalItems = results.scheduled?.total_items || 0;
          this.scheduledTotalPages = results.scheduled?.total_pages || 0;
        }

        // Process completed tasks
        if (results.completed && results.completed.items.length > 0) {
          const completedData = results.completed.items.sort(
            (a, b) =>
              new Date(b.scheduled_date).getTime() -
              new Date(a.scheduled_date).getTime(),
          );
          this.complitedTasks$.next(completedData);
          this.completedTotalItems = results.completed.total_items;
          this.completedTotalPages = results.completed.total_pages;
          this.completedPage = results.completed.current_page;
        } else {
          this.complitedTasks$.next([]);
          this.completedTotalItems = results.completed?.total_items || 0;
          this.completedTotalPages = results.completed?.total_pages || 0;
        }

        // Combine both for form creation
        const allTasks = [
          ...(results.scheduled?.items || []),
          ...(results.completed?.items || []),
        ];
        this.clientTasks = allTasks;
        this.clientTasks$.next(this.clientTasks);

        if (allTasks.length > 0) {
          this.formGroup = this.createGroup();
        }

        this.showSkeleton = false;
        this.loading.next(false);
        this.scheduledLoading = false;
        this.completedLoading = false;
        this.changeDetectorRef.detectChanges();
      },
      error: (error) => {
        console.error('Error in forkJoin:', error);
        this.plannedTasks$.next([]);
        this.complitedTasks$.next([]);
        this.showSkeleton = false;
        this.loading.next(false);
        this.scheduledLoading = false;
        this.completedLoading = false;
        this.changeDetectorRef.detectChanges();
      },
    });
  }

  getScheduledTasks(
    pageNumber: number = this.scheduledPage,
    pageSize: number = this.scheduledPageSize,
  ) {
    this.scheduledLoading = true;
    const allParams: TASK_TYPE[] = [
      { paramName: 'PageSize', paramValue: pageSize.toString() },
      { paramName: 'PageNumber', paramValue: pageNumber.toString() },
      { paramName: 'Status', paramValue: TaskStatus.Scheduled.toString() },
    ];

    this.taskService
      .GetAllTaskByClientId(this.clientId(), allParams)
      .subscribe({
        next: (response: ClientTasks) => {
          this.loading.next(false);
          this.scheduledLoading = false;
          if (response && response.items.length > 0) {
            const res: Task[] = response.items as Task[];
            const plannedData = res.sort(
              (a, b) =>
                new Date(b.scheduled_date).getTime() -
                new Date(a.scheduled_date).getTime(),
            );
            this.plannedTasks$.next(plannedData);

            // Update pagination info from API response
            this.scheduledTotalItems = response.total_items;
            this.scheduledTotalPages = response.total_pages;
            this.scheduledPage = response.current_page;

            // Update clientTasks for form creation (combine both if needed)
            const currentCompleted = this.complitedTasks$.getValue();
            this.clientTasks = [...plannedData, ...currentCompleted];
            this.clientTasks$.next(this.clientTasks);
            this.formGroup = this.createGroup();
          } else {
            this.plannedTasks$.next([]);
            this.scheduledTotalItems = response?.total_items || 0;
            this.scheduledTotalPages = response?.total_pages || 0;
          }
          this.showSkeleton = false;
          this.loading.next(false);
          this.changeDetectorRef.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching scheduled tasks:', error);
          this.loading.next(false);
          this.scheduledLoading = false;
          this.showSkeleton = false;
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  getCompletedTasks(
    pageNumber: number = this.completedPage,
    pageSize: number = this.completedPageSize,
  ) {
    this.completedLoading = true;
    const allParams: TASK_TYPE[] = [
      { paramName: 'PageSize', paramValue: pageSize.toString() },
      { paramName: 'PageNumber', paramValue: pageNumber.toString() },
      { paramName: 'Status', paramValue: TaskStatus.Completed.toString() },
    ];

    this.taskService
      .GetAllTaskByClientId(this.clientId(), allParams)
      .subscribe({
        next: (response: ClientTasks) => {
          this.loading.next(false);
          this.completedLoading = false;
          if (response && response.items.length > 0) {
            const res: Task[] = response.items as Task[];
            const completedData = res.sort(
              (a, b) =>
                new Date(b.scheduled_date).getTime() -
                new Date(a.scheduled_date).getTime(),
            );
            this.complitedTasks$.next(completedData);

            // Update pagination info from API response
            this.completedTotalItems = response.total_items;
            this.completedTotalPages = response.total_pages;
            this.completedPage = response.current_page;

            // Update clientTasks for form creation (combine both if needed)
            const currentPlanned = this.plannedTasks$.getValue();
            this.clientTasks = [...currentPlanned, ...completedData];
            this.clientTasks$.next(this.clientTasks);
            this.formGroup = this.createGroup();
          } else {
            this.complitedTasks$.next([]);
            this.completedTotalItems = response?.total_items || 0;
            this.completedTotalPages = response?.total_pages || 0;
          }
          this.showSkeleton = false;
          this.loading.next(false);
          this.changeDetectorRef.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching completed tasks:', error);
          this.loading.next(false);
          this.completedLoading = false;
          this.showSkeleton = false;
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  createGroup() {
    const group = this.fb.group({});
    this.clientTasks.forEach((control) => {
      let selectedConvertibility: any;
      let selectedOpportunity: any;
      if (control.oppportunity_info) {
        selectedConvertibility = this.convertibility.find(
          (s: any) => s.name == control.oppportunity_info.hot_warm_cold,
        );
        selectedOpportunity = this.opportunityStageCollection.find(
          (s: any) => s.value == control.oppportunity_info.stage_master_id,
        );
      }
      group.addControl(
        'covertability_' + control.id,
        new UntypedFormControl(selectedConvertibility ?? null, []),
      );
      group.addControl(
        'schedule_date_' + control.id,
        new UntypedFormControl(new Date(control.scheduled_date), []),
      );
      group.addControl(
        'selcetdAssigned_' + control.id,
        new UntypedFormControl(control.assigned_to_staff_id, []),
      );
      group.addControl(
        'selectedOpportunity_' + control.id,
        new UntypedFormControl(selectedOpportunity ?? null, []),
      );
      group.addControl(
        'task_title_' + control.id,
        new UntypedFormControl(control.title, []),
      );
      group.addControl(
        'task_notes_' + control.id,
        new UntypedFormControl(control.notes, []),
      );

      if (
        control.oppportunity_info &&
        control.oppportunity_info.expected_closure_date
      ) {
        group.addControl(
          'expected_closure_month_' + control.id,
          new UntypedFormControl(
            new Date(
              control.oppportunity_info
                ? control.oppportunity_info.expected_closure_date
                : new Date(),
            ),
            [],
          ),
        );
      } else
        group.addControl(
          'expected_closure_month_' + control.id,
          new UntypedFormControl('', []),
        );

      if (
        control.oppportunity_info &&
        control.oppportunity_info.service_type.length > 0
      ) {
        const selectedServiceType = this.serviceTypeCollection.filter(
          (allservice: { id: any }) => {
            return control.oppportunity_info.service_type.some(function (
              service: any,
            ) {
              return allservice.id === service.id;
            });
          },
        );
        group.addControl(
          'service_type_ids_' + control.id,
          new UntypedFormControl(selectedServiceType, []),
        );
      } else {
        group.addControl(
          'service_type_ids_' + control.id,
          new UntypedFormControl([], []),
        );
      }

      if (
        control.oppportunity_info &&
        control.oppportunity_info.value_in_minor_currency
      ) {
        group.addControl(
          'value_in_minor_currency_' + control.id,
          new UntypedFormControl(
            this.commonService.ConvertAmountFromMinorCurrency(
              control.oppportunity_info.value_in_minor_currency,
            ),
            [],
          ),
        );
      } else
        group.addControl(
          'value_in_minor_currency_' + control.id,
          new UntypedFormControl(0, []),
        );

      this.dynamicArray.push({
        name: 'expected_closure_month_' + control.id,
        value: false,
      });
      this.dynamicArray.push({
        name: 'schedule_date_' + control.id,
        value: false,
      });
      this.dynamicArray.push({
        name: 'value_in_minor_currency_' + control.id,
        value: false,
      });
      this.dynamicArray.push({
        name: 'task_title_' + control.id,
        value: false,
      });
      this.dynamicArray.push({
        name: 'task_notes_' + control.id,
        value: false,
      });
      group.addControl(
        'task_comments_' + control.id,
        new UntypedFormControl('', [Validators.required]),
      );

      if (
        this.currentUserDetails &&
        this.currentUserDetails['can_admin_client_profiles'] == 'false'
      ) {
        group.get('selcetdAssigned_' + control.id)?.disable();
      } else {
        group.get('selcetdAssigned_' + control.id)?.enable();
      }
    });
    return group;
  }

  BindOpportunityStageMaster(): void {
    this.store.select(STAGE_MASTER_STATE).subscribe((res: any) => {
      this.opportunityStageCollection = [];
      const opportunities = res as any;
      opportunities.forEach(
        (opportunityStage: OpportunityStageMasterResponse) => {
          this.opportunityStageCollection.push({
            name: opportunityStage.name_primary_language,
            value: opportunityStage.id,
          });
        },
      );
    });
  }

  BindServiceType(): void {
    this.store.select(SERVICETYPE_LIST_STATE).subscribe((serviceTypes: any) => {
      this.serviceTypeCollection = serviceTypes;
    });
  }

  getStageStatus(stageMasterid: number): Observable<string | undefined> {
    return this.store
      .select(STAGE_MASTER_STATE)
      .pipe(
        map(
          (value: STAGE_MASTER_MODEL[]) =>
            value.find((obj) => obj.id == stageMasterid)?.name_primary_language,
        ),
      );
  }

  getBackgroundColor(taskType: string) {
    let colorCode: string = '';
    const data = TaskType[taskType as keyof typeof TaskType];
    switch (data) {
      case TaskType.Call:
        colorCode = 'bg-cyan-100';
        break;
      case TaskType.Tour:
        colorCode = 'bg-orange-100';
        break;
      case TaskType.Email:
        colorCode = 'bg-indigo-100';
        break;
      case TaskType.Sms:
        colorCode = 'bg-teal-100';
        break;
    }
    return colorCode;
  }

  getTaskTypeIcon(taskType: string) {
    let icon: string = '';
    const data = TaskType[taskType as keyof typeof TaskType];
    switch (data) {
      case TaskType.Call:
        icon = 'fa fa-phone text-lg mr-2';
        break;
      case TaskType.Tour:
        icon = 'fa fa-map-marker-alt text-lg mr-2';
        break;
      case TaskType.Email:
        icon = ' fa fa-envelope font-light text-lg mr-2';
        break;
      case TaskType.Sms:
        icon = 'fa fa-comments font-light text-lg mr-2';
        break;
    }
    return icon;
  }

  getSelectedStaff(trainer: any, task: Task) {
    this.UpdateAssignTo(trainer, task);
  }

  EditTaskTitle(task: Task) {
    if (task.title == this.TaskTitleFormControl(task.id).value) {
      this.setformShowValue('task_title_' + task.id, false);
      return;
    }
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = this.SelectedAssignedFormControl(
      task.id,
    ).value.id;
    updateTask.notes = this.TaskNotesFormControl(task.id).value;
    updateTask.title = this.TaskTitleFormControl(task.id).value;
    updateTask.priority = task.priority;
    updateTask.scheduled_date = this.TaskScheduledDateFormControl(
      task.id,
    ).value;
    updateTask.category_id = task.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;

    this.UpdateTask(updateTask, task).then((res) => {
      if (res) {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();
        if (plannedTasks.find((o) => o.id == task.id)) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id) o.title = updateTask.title;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (complitedTask.find((o) => o.id == task.id)) {
          complitedTask.forEach((o) => {
            if (o.id == task.id) o.title = updateTask.title;
          });
          this.complitedTasks$.next(complitedTask);
        }
      } else this.TaskTitleFormControl(task.id).setValue(task.title);
      this.setformShowValue('task_title_' + task.id, false);
    });
  }

  EditTaskNotes(task: Task) {
    if (task.notes == this.TaskNotesFormControl(task.id).value) {
      this.setformShowValue('task_notes_' + task.id, false);
      return;
    }
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = this.SelectedAssignedFormControl(
      task.id,
    ).value.id;
    updateTask.notes = this.TaskNotesFormControl(task.id).value;
    updateTask.title = task.title;
    updateTask.priority = task.priority;
    updateTask.scheduled_date = this.TaskScheduledDateFormControl(
      task.id,
    ).value;
    updateTask.category_id = task.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;

    this.UpdateTask(updateTask, task).then((res) => {
      if (res) {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();
        if (plannedTasks.find((o) => o.id == task.id)) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id) o.notes = updateTask.notes;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (complitedTask.find((o) => o.id == task.id)) {
          complitedTask.forEach((o) => {
            if (o.id == task.id) o.notes = updateTask.notes;
          });
          this.complitedTasks$.next(complitedTask);
        }
      } else this.TaskNotesFormControl(task.id).setValue(task.title);
      this.setformShowValue('task_notes_' + task.id, false);
    });
  }

  UpdateAssignTo(trainer: any, task: Task) {
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = this.SelectedAssignedFormControl(
      task.id,
    ).value.id;
    updateTask.notes = task.notes;
    updateTask.title = task.title;
    updateTask.priority = task.priority;
    updateTask.scheduled_date = this.TaskScheduledDateFormControl(
      task.id,
    ).value;
    updateTask.category_id = task.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;
    this.UpdateTask(updateTask, task).then((res) => {
      if (!res) {
        this.SelectedAssignedFormControl(task.id).setValue(
          task.assigned_to_staff_id,
        );
      } else {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();
        if (
          plannedTasks.find(
            (o) => o.assigned_to_staff_id == updateTask.assigned_to_staff_id,
          )
        ) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id)
              o.assigned_to_staff_id = updateTask.assigned_to_staff_id;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (
          complitedTask.find(
            (o) => o.assigned_to_staff_id == updateTask.assigned_to_staff_id,
          )
        ) {
          complitedTask.forEach((o) => {
            if (o.id == task.id)
              o.assigned_to_staff_id = updateTask.assigned_to_staff_id;
          });
          this.complitedTasks$.next(complitedTask);
        }
      }
    });
  }

  UpdateConvartability(e: any, task: Task) {
    const updateOpportunity: UpdateOpportunityRequest =
      {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = task.assigned_to_staff_id;
    updateOpportunity.comments = '';
    updateOpportunity.expected_closure_date = new Date(
      task.oppportunity_info.expected_closure_date,
    );
    updateOpportunity.hot_warm_cold = this.SelectedConvertibility(task.id).name;
    updateOpportunity.name = task.oppportunity_info.name;
    updateOpportunity.service_type_ids = this.TaskServiceTypesControl(
      task.id,
    ).value.map((s: { id: any }) => {
      return s.id;
    });
    updateOpportunity.stage_master_id = this.SelectedOpportunity(task.id)
      ? this.SelectedOpportunity(task.id).id
      : 0;
    updateOpportunity.value_in_minor_currency =
      this.commonService.ConvertMinorCurrencyFromAmount(
        this.AmountFormControl(task.id).value,
      );
    this.UpdateOpportunity(updateOpportunity, task).then((res) => {
      if (!res) {
        const selectedConvertibility = this.convertibility.find(
          (s: any) => s.name == task.oppportunity_info.hot_warm_cold,
        );
        this.SelectedConvertibilityFormControl(task.id).setValue(
          selectedConvertibility,
          { onlySelf: true },
        );
      } else {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();
        if (
          plannedTasks.find(
            (o) =>
              o.oppportunity_info.hot_warm_cold ==
              task.oppportunity_info.hot_warm_cold,
          )
        ) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id)
              o.oppportunity_info.hot_warm_cold =
                task.oppportunity_info.hot_warm_cold;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (
          complitedTask.find(
            (o) =>
              o.oppportunity_info.hot_warm_cold ==
              task.oppportunity_info.hot_warm_cold,
          )
        ) {
          complitedTask.forEach((o) => {
            if (o.id == task.id)
              o.oppportunity_info.hot_warm_cold =
                task.oppportunity_info.hot_warm_cold;
          });
          this.complitedTasks$.next(complitedTask);
        }
      }
    });
  }

  UpdateOpportunityStage(e: any, task: Task) {
    const updateOpportunity: UpdateOpportunityRequest =
      {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = this.SelectedAssignedFormControl(
      task.id,
    ).value.id;
    updateOpportunity.comments = '';
    updateOpportunity.expected_closure_date = new Date(
      task.oppportunity_info.expected_closure_date,
    );
    updateOpportunity.hot_warm_cold = task.oppportunity_info.hot_warm_cold;
    updateOpportunity.name = task.oppportunity_info.name;
    updateOpportunity.service_type_ids = this.TaskServiceTypesControl(
      task.id,
    ).value.map((s: { id: any }) => {
      return s.id;
    });
    updateOpportunity.stage_master_id = e.value.value;
    updateOpportunity.value_in_minor_currency =
      this.commonService.ConvertMinorCurrencyFromAmount(
        this.AmountFormControl(task.id).value,
      );
    this.UpdateOpportunity(updateOpportunity, task).then((res) => {
      if (!res) {
        const selectedOpportunity = this.opportunityStageCollection.find(
          (s) => s.value == task.oppportunity_info.stage_master_id,
        );
        this.SelectedOpportunityFormControl(task.id).setValue(
          selectedOpportunity,
          { onlySelf: true },
        );
      } else {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();

        if (
          plannedTasks.find(
            (o) =>
              o.oppportunity_info.stage_master_id ==
              updateOpportunity.stage_master_id,
          )
        ) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id)
              o.oppportunity_info.stage_master_id =
                updateOpportunity.stage_master_id;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (
          complitedTask.find(
            (o) =>
              o.oppportunity_info.stage_master_id ==
              updateOpportunity.stage_master_id,
          )
        ) {
          complitedTask.forEach((o) => {
            if (o.id == task.id)
              o.oppportunity_info.stage_master_id =
                updateOpportunity.stage_master_id;
          });
          this.complitedTasks$.next(complitedTask);
        }
      }
    });
  }

  OnScheduleDateSelect(e: any, task: Task) {
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = this.SelectedAssignedFormControl(
      task.id,
    ).value.id;
    updateTask.notes = task.notes;
    updateTask.title = task.title;
    updateTask.priority = task.priority;
    updateTask.scheduled_date = this.timeService.ConvertLocalDateTimeToUTC(e);
    updateTask.category_id = task.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;
    this.UpdateTask(updateTask, task).then((res) => {
      if (res) {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();
        if (this.plannedTasks$.getValue().find((o) => o.id == task.id)) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id) o.scheduled_date = e;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (
          this.complitedTasks$.getValue().find((o) => o.id == task.id)
        ) {
          complitedTask.forEach((o) => {
            if (o.id == task.id) o.scheduled_date = e;
          });
          this.complitedTasks$.next(complitedTask);
        }
      } else {
        this.TaskScheduledDateFormControl(task.id).setValue(
          task.scheduled_date,
        );
      }
      this.setformShowValue('schedule_date_' + task.id, false);
    });
  }

  OnExpectedClosureDateSelect(e: any, task: Task) {
    const updateOpportunity: UpdateOpportunityRequest =
      {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = this.SelectedAssignedFormControl(
      task.id,
    ).value.id;
    updateOpportunity.comments = '';
    updateOpportunity.expected_closure_date = e.toISOString();
    updateOpportunity.hot_warm_cold = task.oppportunity_info.hot_warm_cold;
    updateOpportunity.name = task.oppportunity_info.name;
    updateOpportunity.service_type_ids = this.TaskServiceTypesControl(
      task.id,
    ).value.map((s: { id: any }) => {
      return s.id;
    });
    updateOpportunity.stage_master_id = this.SelectedOpportunity(task.id)
      ? this.SelectedOpportunity(task.id).id
      : 0;
    updateOpportunity.value_in_minor_currency =
      this.commonService.ConvertMinorCurrencyFromAmount(
        this.AmountFormControl(task.id).value,
      );
    this.UpdateOpportunity(updateOpportunity, task).then((res) => {
      if (res) {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();
        if (plannedTasks.find((o) => o.id == task.id)) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id) o.oppportunity_info.expected_closure_date = e;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (complitedTask.find((o) => o.id == task.id)) {
          complitedTask.forEach((o) => {
            if (o.id == task.id) o.oppportunity_info.expected_closure_date = e;
          });
          this.complitedTasks$.next(complitedTask);
        }
      } else {
        this.ExpectedClosureDateFormControl(task.id).setValue(
          new Date(task.oppportunity_info.expected_closure_date),
        );
      }
      this.setformShowValue('expected_closure_month_' + task.id, false);
    });
  }

  UpdateAmount(task: Task) {
    const updateOpportunity: UpdateOpportunityRequest =
      {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = this.SelectedAssignedFormControl(
      task.id,
    ).value.id;
    updateOpportunity.comments = '';
    updateOpportunity.expected_closure_date =
      this.ExpectedClosureDateFormControl(task.id).value;
    updateOpportunity.hot_warm_cold = task.oppportunity_info.hot_warm_cold;
    updateOpportunity.name = task.oppportunity_info.name;
    updateOpportunity.service_type_ids = this.TaskServiceTypesControl(
      task.id,
    ).value.map((s: { id: any }) => {
      return s.id;
    });
    updateOpportunity.stage_master_id = this.SelectedOpportunity(task.id)
      ? this.SelectedOpportunity(task.id).id
      : 0;
    updateOpportunity.value_in_minor_currency =
      this.commonService.ConvertMinorCurrencyFromAmount(
        this.AmountFormControl(task.id).value,
      );
    this.UpdateOpportunity(updateOpportunity, task).then((res) => {
      if (res) {
        const plannedTasks = this.plannedTasks$.getValue();
        const complitedTask = this.complitedTasks$.getValue();
        if (plannedTasks.find((o) => o.id == task.id)) {
          plannedTasks.forEach((o) => {
            if (o.id == task.id)
              o.oppportunity_info.value_in_minor_currency =
                updateOpportunity.value_in_minor_currency;
          });
          this.plannedTasks$.next(plannedTasks);
        } else if (complitedTask.find((o) => o.id == task.id)) {
          complitedTask.forEach((o) => {
            if (o.id == task.id)
              o.oppportunity_info.value_in_minor_currency =
                updateOpportunity.value_in_minor_currency;
          });
          this.complitedTasks$.next(complitedTask);
        }
      } else
        this.AmountFormControl(task.id).setValue(
          this.commonService.ConvertAmountFromMinorCurrency(
            task.oppportunity_info.value_in_minor_currency,
          ),
          { onlySelf: true },
        );
    });
    this.setformShowValue('value_in_minor_currency_' + task.id, false);
  }

  UpdateServiceType(
    isRemoved: boolean,
    e: any,
    form: UntypedFormGroup,
    task: Task,
  ) {
    if (
      isRemoved &&
      this.TaskServiceTypesControl(task.id).value &&
      this.TaskServiceTypesControl(task.id).value.length == 0
    ) {
      this.translate
        .get('Shared.TASK-OPPORTUNITY-INFO.INTERESTEDIN_MIN_ERROR')
        .subscribe((translation) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: translation,
          });
        });
      this.TaskServiceTypesControl(task.id).setValue([e]);
      return;
    } else {
      setTimeout(() => {
        const updateOpportunity: UpdateOpportunityRequest =
          {} as UpdateOpportunityRequest;
        updateOpportunity.assigned_to_staff_id =
          this.SelectedAssignedFormControl(task.id).value.id;
        updateOpportunity.comments = '';
        updateOpportunity.expected_closure_date =
          this.ExpectedClosureDateFormControl(task.id).value;
        updateOpportunity.hot_warm_cold = task.oppportunity_info.hot_warm_cold;
        updateOpportunity.name = task.oppportunity_info.name;
        updateOpportunity.service_type_ids = this.TaskServiceTypesControl(
          task.id,
        ).value.map((s: { id: any }) => {
          return s.id;
        });
        updateOpportunity.stage_master_id = this.SelectedOpportunity(task.id)
          ? this.SelectedOpportunity(task.id).id
          : 0;
        updateOpportunity.value_in_minor_currency =
          this.commonService.ConvertMinorCurrencyFromAmount(
            this.AmountFormControl(task.id).value,
          );
        this.UpdateOpportunity(updateOpportunity, task).then((res) => {
          if (res) {
            const plannedTasks = this.plannedTasks$.getValue();
            const complitedTask = this.complitedTasks$.getValue();
            if (plannedTasks.find((o) => o.id == task.id)) {
              plannedTasks.forEach((o) => {
                if (o.id == task.id)
                  o.oppportunity_info.service_type =
                    this.TaskServiceTypesControl(task.id).value;
              });
              this.plannedTasks$.next(plannedTasks);
            } else if (complitedTask.find((o) => o.id == task.id)) {
              complitedTask.forEach((o) => {
                if (o.id == task.id)
                  o.oppportunity_info.service_type =
                    this.TaskServiceTypesControl(task.id).value;
              });
              this.complitedTasks$.next(complitedTask);
            }
          } else {
            const selectedServiceType = this.serviceTypeCollection.filter(
              (o: any) => {
                return task.oppportunity_info.service_type.some(function (
                  o2: any,
                ) {
                  return o.id === o2.id;
                });
              },
            );
            this.TaskServiceTypesControl(task.id).setValue(selectedServiceType);
          }
        });
      }, 3000);
    }
  }

  UpdateTask(updateTask: UpdateTask, task: Task): Promise<boolean> {
    const promise: Promise<boolean> = new Promise((resolve) => {
      this.taskService
        .UpdateTaskService(this.tenantId, task.id, updateTask)
        .subscribe({
          next: () => {
            this.translate
              .get('Shared.TASK-OPPORTUNITY-INFO.TASK_UPDATE_MSG')
              .subscribe((translation) => {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: translation,
                });
              });
            resolve(true);
          },
          error: (error: any) => {
            this.ShowToastErrors(error);
            resolve(false);
          },
        });
    });
    return promise;
  }

  UpdateOpportunity(updateOpportunity: UpdateOpportunityRequest, task: Task) {
    const promise: Promise<boolean> = new Promise((resolve) => {
      this.opportunityService
        .OpportunityUpdateService(
          this.tenantId,
          task.oppportunity_info.board_type,
          task.oppportunity_info.id,
          updateOpportunity,
        )
        .subscribe({
          next: () => {
            this.translate
              .get('Shared.TASK-OPPORTUNITY-INFO.OPPT_UPDATE_MSG')
              .subscribe((translation) => {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: translation,
                });
              });
            resolve(true);
          },
          error: (error: any) => {
            this.ShowToastErrors(error);
            resolve(false);
          },
        });
    });
    return promise;
  }

  filterServiceType(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.serviceTypeCollection.length; i++) {
      const serviceType = this.serviceTypeCollection[i];
      if (
        serviceType.name_primary_language
          .toLowerCase()
          .indexOf(query.toLowerCase()) == 0 ||
        serviceType.name_secondary_language
          .toLowerCase()
          .indexOf(query.toLowerCase()) == 0
      ) {
        filtered.push(serviceType);
      }
    }

    this.filtertedServiceType = filtered;
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: e.errorMessage,
        });
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error.originalError.error.errorMessage,
      });
    }
  }

  SetOutComeDetails(task: Task) {
    const taskDetails: any = {};
    const latestTask: LatestTask = {} as LatestTask;
    latestTask.category_id = task.category_id;
    latestTask.name_primary_language = task.name_primary_language;
    latestTask.name_secondary_language = task.name_secondary_language;
    latestTask.priority = task.priority.toString();
    latestTask.scheduled_date = task.scheduled_date;
    latestTask.status = task.status.toString();
    latestTask.title = task.title;
    latestTask.type = task.type.toString();
    latestTask.id = task.id;

    taskDetails.company_id = task.company_id;
    taskDetails.tenant_id = task.tenant_id;
    taskDetails.client_info = task.client_info;

    taskDetails.service_type = [];
    if (task.oppportunity_info) {
      taskDetails.board_type = task.oppportunity_info.board_type;
      taskDetails.hot_warm_cold = task.oppportunity_info.hot_warm_cold;
      taskDetails.expected_closure_date =
        task.oppportunity_info.expected_closure_date;
      taskDetails.id = task.oppportunity_info.id;
      taskDetails.stage_master_id = task.oppportunity_info.stage_master_id;
      taskDetails.value_in_minor_currency =
        task.oppportunity_info.value_in_minor_currency;
      taskDetails.service_type = task.oppportunity_info.service_type;
      taskDetails.name = task.oppportunity_info.name;
    }
    taskDetails.assigned_to_staff_id = task.assigned_to_staff_id;
    taskDetails.comments = '';
    taskDetails.latest_task = latestTask;
    this.outcomeDetail = taskDetails;
    if (
      task.type == TaskType.Tour ||
      task.type.toString() == TaskType[TaskType.Tour]
    ) {
      this.showMeetingOutcomePopup = true;
    } else {
      this.showCallOutcomePopup = true;
    }
  }

  CreateComments(task: Task) {
    this.btnLoading = true;
    const createcomments: CreateComments = {} as CreateComments;
    createcomments.comments_content = this.TaskCommentsFormControl(
      task.id,
    ).value;
    this.commentsService
      .CreateTaskComment(this.tenantId, task.id, createcomments)
      .subscribe({
        next: (data: any) => {
          const comment: Comments = {} as Comments;
          comment.comments_id = data.id;
          comment.comments_tenant_id = this.tenantId;
          comment.comments_content = createcomments.comments_content;
          comment.comments_created_by = this.currentUserDetails.Id;
          comment.comments_created_date =
            this.timeService.ConvertLocalDateTimeToUTC(new Date());
          comment.comments_updated_by = comment.comments_created_by;
          comment.comments_task_id = task.id;
          const plannedTasks = this.plannedTasks$.getValue();
          const complitedTask = this.complitedTasks$.getValue();
          if (plannedTasks.find((o) => o.id == task.id)) {
            plannedTasks.forEach((o) => {
              if (o.id == task.id) {
                if (o.comments != null) o.comments.push(comment);
                else {
                  o.comments = [];
                  o.comments.push(comment);
                }
              }
            });
            this.plannedTasks$.next(plannedTasks);
          } else if (complitedTask.find((o) => o.id == task.id)) {
            complitedTask.forEach((o) => {
              if (o.id == task.id) {
                if (o.comments != null) o.comments.push(comment);
                else {
                  o.comments = [];
                  o.comments.push(comment);
                }
              }
            });
            this.complitedTasks$.next(complitedTask);
          }
          this.translate
            .get('CLIENT_TASK.COMMENTS_CREATED')
            .subscribe((translation) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: translation,
              });
            });
          this.TaskCommentsFormControl(task.id).setValue(null);
          this.btnLoading = false;
        },
        error: (error: any) => {
          this.ShowToastErrors(error);
          this.btnLoading = false;
        },
      });
  }

  DeleteComment(comment: Comments) {
    this.commentsService
      .DeleteTaskComment(
        this.tenantId,
        comment.comments_task_id,
        comment.comments_id,
      )
      .subscribe({
        next: (data: any) => {
          const plannedTasks = this.plannedTasks$.getValue();
          const complitedTask = this.complitedTasks$.getValue();
          if (plannedTasks.find((o) => o.id == comment.comments_task_id)) {
            plannedTasks.forEach((o) => {
              if (o.id == comment.comments_task_id) {
                o.comments = o.comments.filter(
                  (c) => c.comments_id !== comment.comments_id,
                );
              }
            });
            this.plannedTasks$.next(plannedTasks);
          } else if (
            complitedTask.find((o) => o.id == comment.comments_task_id)
          ) {
            complitedTask.forEach((o) => {
              if (o.id == comment.comments_task_id) {
                o.comments = o.comments.filter(
                  (c) => c.comments_id !== comment.comments_id,
                );
              }
            });
            this.complitedTasks$.next(complitedTask);
          }
          this.translate
            .get('CLIENT_TASK.COMMENTS_DELETED')
            .subscribe((translation) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: translation,
              });
            });
        },
        error: (error: any) => {
          this.ShowToastErrors(error);
        },
      });
  }

  HideOutComePopup(event: any) {
    this.showCallOutcomePopup = false;
    this.showMeetingOutcomePopup = false;
    if (event.modified) {
      this.loadAllTasks();
    }
  }

  sanitizeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngAfterViewInit() {
    this.removeQlImage();
  }

  removeQlImage() {
    const imgButton = document.getElementsByClassName('ql-image');
    for (let i = 0; i < imgButton.length; i++) {
      imgButton[i].remove();
    }

    const cleanButton = document.getElementsByClassName('ql-clean');
    for (let i = 0; i < cleanButton.length; i++) {
      cleanButton[i].remove();
    }

    const codeBlock = document.getElementsByClassName('ql-code-block');
    for (let i = 0; i < codeBlock.length; i++) {
      codeBlock[i].remove();
    }
    const linkButton = document.getElementsByClassName('ql-link');
    for (let i = 0; i < linkButton.length; i++) {
      linkButton[i].remove();
    }
  }

  GoToClientDetails(event: any) {
    this.activeClientId = event.clientId;
    this.showClientSidebar = true;
  }

  assignedId(staffId: number) {
    return new BehaviorSubject<number>(staffId);
  }

  getformShowValue(name: string) {
    return this.dynamicArray.find((o) => o.name == name)?.value;
  }

  setformShowValue(name: string, value: boolean) {
    this.dynamicArray.forEach((o) => {
      if (o.name == name) o.value = value;
    });
  }

  SelectedConvertibility(taskId: number) {
    return this.formGroup.get('covertability_' + taskId)?.value;
  }

  SelectedConvertibilityFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get('covertability_' + taskId) as UntypedFormControl;
  }

  SelectedAssignedFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get(
      'selcetdAssigned_' + taskId,
    ) as UntypedFormControl;
  }

  SelectedOpportunity(taskId: number) {
    return this.formGroup.get('selectedOpportunity_' + taskId)?.value;
  }

  SelectedOpportunityFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get(
      'selectedOpportunity_' + taskId,
    ) as UntypedFormControl;
  }

  TaskScheduledDateFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get('schedule_date_' + taskId) as UntypedFormControl;
  }

  TaskServiceTypesControl(taskId: number): UntypedFormControl {
    return this.formGroup.get(
      'service_type_ids_' + taskId,
    ) as UntypedFormControl;
  }

  AmountFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get(
      'value_in_minor_currency_' + taskId,
    ) as UntypedFormControl;
  }

  ExpectedClosureDateFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get(
      'expected_closure_month_' + taskId,
    ) as UntypedFormControl;
  }

  TaskCommentsFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get('task_comments_' + taskId) as UntypedFormControl;
  }

  TaskTitleFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get('task_title_' + taskId) as UntypedFormControl;
  }

  TaskNotesFormControl(taskId: number): UntypedFormControl {
    return this.formGroup.get('task_notes_' + taskId) as UntypedFormControl;
  }

  TaskCommentsFormControlStatus(taskId: number) {
    this.removeQlImage();
    return this.formGroup.get('task_comments_' + taskId)?.invalid;
  }

  isCompleted(task: Task) {
    if (task.status === undefined || task.status === null) return false;
    return task.status == TaskStatus.Completed ||
      task.status.toString() == TaskStatus[TaskStatus.Completed]
      ? true
      : false;
  }

  newTask() {
    this.clientIds = [];
    this.clientIds.push(this.clientId());
    this.showTaskCreate = true;
  }

  showTaskCreateMultiple() {
    this.showTaskMultiple = true;
  }

  HideTaskCreate(e: any) {
    this.showTaskCreate = e.closePopup;
  }

  closeTaskPopup(event: any) {
    this.showTaskCreate = false;
    if (event.refreshdata) {
      this.loadAllTasks();
    }
  }

  HideTaskCreateMulti(e: any) {
    this.showTaskMultiple = false;
  }

  numSequence(n: number): Array<number> {
    return Array(n);
  }

  public get TaskType() {
    return TaskType;
  }

  onScheduledPageChange(event: any) {
    this.scheduledPage = event.page + 1; // PrimeNG uses 0-based index, API uses 1-based
    this.scheduledPageSize = event.rows;
    this.getScheduledTasks(this.scheduledPage, this.scheduledPageSize);
  }

  onCompletedPageChange(event: any) {
    this.completedPage = event.page + 1; // PrimeNG uses 0-based index, API uses 1-based
    this.completedPageSize = event.rows;
    this.getCompletedTasks(this.completedPage, this.completedPageSize);
  }
}

interface Option {
  name: string;
  value: number;
}

interface ShowHideControl {
  name: string;
  value: boolean;
}
